import React from "react";
import {Alert, Button} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import moment from "moment";
import ajax from "./../../lib/ajax.js";
import immutable from 'immutable';
import context from "./../../lib/context.js";

export default class DelegateList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            delegateList: [],
            showError: false,
            errors: [],
            message: ''
        }

        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let list = immutable.fromJS(nextProps.vm).toJS();
        if (list != null) {
            for(let i=0; i<list.length; i++)
                list[i].startDatePrev = list[i].startDate;
        }
        this.setState({delegateList: list});
    }

    onFieldChange(recordIndex, fieldName, value) {
        this.state.delegateList;
    }

    onDelete(delegateId) {
        const self = this;
        let clone = immutable.fromJS(this.state).toJS();
        context.message({
            show :true,
            type : "info",
            message: "Are you sure you want to delete this delegate?",
            buttons: "yes,no"
        }, function(button, s) {
            // s is delegateId, delegateId is set as the 3rd parameter of context.message
            if (button === "yes") {
                context.message({
                    show: true,
                    type:"loading",
                    message: "Deleting Delegate. Please wait..."            
                });
                ajax.api()
                    .delete("delete-delegate/" + s)
                    .then(function(res) {
                        context.message({
                            show: false
                        });

                        clone.delegateList = clone.delegateList.filter(function(o) { return o.delegateId != s; });
                        clone.message = 'Deleted successfully';
                        self.setState(clone);
                    })
                    .catch(function(err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"});
                    });                  
            }
        }, delegateId);
    }

    onSave(payload) {
        const self = this;
        let clone = immutable.fromJS(this.state).toJS();
        clone.errors = this.validate(payload);
        if (clone.errors && clone.errors.length > 0) {
            this.setState(clone);
        } else {
            context.message({
                show: true,
                type:"loading",
                message: "Updating delegate. Please wait..."
            });

            ajax.api()
            .put(`update-delegate/${payload.delegateId}`, {
                startDate: moment(payload.startDate).format("MM/DD/YYYY"),
                endDate: moment(payload.endDate).format("MM/DD/YYYY")
            })
            .then(function(res){    
                context.message({
                    show: false
                }); 
                for(let i=0; i<clone.delegateList.length; i++)
                    clone.delegateList[i].startDatePrev = clone.delegateList[i].startDate;

                clone.message = 'Saved successfully';
                self.setState(clone);
            })
            .catch(function(err) {
                let data = err.response.data;
                let clone = immutable.fromJS(self.state).toJS();
                clone.errors = [];

                if (data.ClassName === "ActionPortal.ValidationException") {
                    for(let key in data.Data.summary.validationResults)
                        clone.errors.push(data.Data.summary.validationResults[key]);
                } else {
                    clone.errors = [data.exceptionMessage || data.message];
                }

                self.setState(clone);

                context.message({
                    show: false,          
                });
            });
        }
    }

    validate(obj) {
        let msg = [];
        let s_startDate = null;
        let s_endDate = null;
        let s_now = moment().format("YYYY-MM-DD");

        if (!obj.startDate || obj.startDate.trim().length == 0) {
            msg.push("Start Date is required");
        } else {
            s_startDate = moment(obj.startDate).format("YYYY-MM-DD");
            if (!s_startDate) {
                msg.push("Start Date is invalid");
            }
            else if (obj.startDatePrev) {
                let s_startDatePrev = moment(obj.startDatePrev).format("YYYY-MM-DD");
                if (s_startDate != s_startDatePrev && s_startDate < s_now) {
                    msg.push("Start Date must not be before current date");
                }
            }
        }

        if (!obj.endDate || obj.endDate.trim().length == 0) {
            msg.push("End Date is required");
        } else {
            s_endDate = moment(obj.endDate.trim()).format("YYYY-MM-DD")
            if (!s_endDate) {
                msg.push("End Date is invalid");
            }
            else if (s_endDate < s_now) {
                msg.push("End Date must not be before current date");
            }
        }

        if (s_startDate && s_endDate && s_startDate >  s_endDate) {
            msg.push("Start Date must be before End Date");
        }

        return msg;
    }

    render() {
        let msgText = this.state.message;
        let msgClass = "";
        let msgStyle = "info";

        if (this.state.errors.length > 0) {
            msgStyle = "danger";
            msgText = <ul>{
                        this.state.errors.map(m => <li key={m}>{m}</li>)
                        }
                    </ul>;
        }
        else if (msgText == "") {
            msgClass = "ap-hidden";
        }
        else if (msgText.toUpperCase().indexOf("SUCCESS") > -1) {
            msgStyle = "success";
        }
        
        let items = [];
        let now = moment();
        let list = this.state.delegateList; // Expected to be an array of listItem
        if (list == null || list.length == 0) {
            return(
                <div>
                    <div className="row"> 
                        <div className="col-md-12 ap-fullsize ap-grid-result text-center">
                            No Delegates Found!
                        </div>
                    </div>
                    <div className="row"> 
                        <div className="col-md-12">
                            <Alert bsStyle={msgStyle} className={msgClass}>
                                {msgText}
                            </Alert>
                        </div>
                    </div>
                </div>
                );
        } else {
            for(let i=0; i<list.length; i++) {
                let endDateColor = moment(list[i].endDate) < now? "red": "inherit";
                items.push(
                    <div key={i} className="row ap-delegate-list-item">
                        <section className="hidden-sm hidden-xs">
                            <div className="col-md-3 col-lg-3">
                                {list[i].fullName}
                            </div>
                            <div className="col-md-3 col-lg-3">
                                {list[i].email}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center">
                                {list[i].isActive? "Active": "Inactive"}
                            </div>
                            <div className="col-md-2 col-lg-2">
                                <DatePicker placeholder="MM/DD/YYYY" value={list[i].startDate}
                                    onChange={(val, formattedVal) => list[i].startDate = val}
                                    onInput={(val, formattedVal) => list[i].startDate = val}/>
                            </div>
                            <div className="col-md-2 col-lg-2">
                                <DatePicker placeholder="MM/DD/YYYY" value={list[i].endDate}
                                    style={{color: endDateColor}}
                                    onChange={(val, formattedVal) => list[i].endDate = val}
                                    onInput={(val, formattedVal) => list[i].endDate = val}/>
                            </div>
                            <div className="col-md-1 col-lg-1" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                                <span className="ap-delegate-list-item-icon pull-left"> 
                                    <a onClick={() => this.onSave(list[i])}><i className='fa fa-floppy-o'></i></a>
                                </span>                    
                                <span className="ap-delegate-list-item-icon pull-left">
                                    <a onClick={() => this.onDelete(list[i].delegateId)}><i className='fa fa-trash-o'></i></a>
                                </span>
                            </div> 
                        </section>


                        <section className="hidden-md hidden-lg">
                            <div className="col-xs-12 col-sm-12">
                                <b>{list[i].fullName}</b>
                            </div> 
                            <div className="col-xs-12 col-sm-12">
                                {list[i].email}
                            </div>
                            <div className="col-xs-12 col-sm-12">
                                <span className="ap-color-gray">Status </span>
                                 {list[i].isActive? "Active": "Inactive"}
                            </div>  
                            <div className="col-xs-12 col-sm-12 ap-separator-col">                        
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Start Date</span><br/>
                                <DatePicker placeholder="MM/DD/YYYY" value={list[i].startDate}
                                    onChange={(val, formattedVal) => list[i].startDate = val}
                                    onInput={(val, formattedVal) => list[i].startDate = val}/>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">End Date</span><br/>
                                <DatePicker placeholder="MM/DD/YYYY" value={list[i].endDate}
                                    style={{color: endDateColor}}
                                    onChange={(val, formattedVal) => list[i].endDate = val}
                                    onInput={(val, formattedVal) => list[i].endDate = val}/>
                            </div>
                            <div className="col-xs-12 col-sm-12 ap-separator-col" style={{marginTop: "5px", marginBottom: "5px"}}></div>
                            <div className="col-xs-6 col-sm-6">
                                <Button className="ap-fullsize btn-info" onClick={() => this.onSave(list[i])}>Save</Button>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <Button className="ap-fullsize" onClick={() => this.onDelete(list[i].delegateId)}>Delete</Button>
                            </div>
                        </section>
                    </div>
                    );              
            }
        }

        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="container-fluid ap-timecard-list-header">
                            <div className="row">
                                <div className="hidden-xs hidden-sm col-md-3 col-lg-3 ap-col-title">
                                    Delegate Name
                                </div>
                                <div className="hidden-xs hidden-sm col-md-3 col-lg-3 ap-col-title">
                                    Email
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title text-center">
                                    Status
                                </div>
                                <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title">
                                    Start Date
                                </div>
                                <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title">
                                    End Date
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="row">                        
                    <div className="col-lg-12">                            
                        <div className="container-fluid ap-delegate-list">
                            {items}
                        </div>
                    </div>
                </div>
                <div className="row"> 
                    <div className="col-md-12">
                        <Alert bsStyle={msgStyle} className={msgClass}>
                            {msgText}
                        </Alert>
                    </div>
                </div>
            </div>
        );
    }
}